import { createFileRoute } from "@tanstack/react-router";
import DepressionKetaminePage from "@/pages/DepressionKetaminePage";
import { buildConditionSchema } from "@/components/ConditionPageLayout";
export const Route = createFileRoute("/depression-treatment-coral-springs-fl")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Depression Treatment Coral Springs Fl | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Depression treatment in Coral Springs, FL. SAINT TMS, standard TMS, SPRAVATO, ketamine, and therapy for treatment-resistant depression Free consultation.",
        },
        {
          property: "og:title",
          content: "Depression Treatment Coral Springs Fl | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Depression treatment in Coral Springs, FL. SAINT TMS, standard TMS, SPRAVATO, ketamine, and therapy for treatment-resistant depression Free consultation.",
        },
        {
          property: "og:url",
          content:
            "https://neurowellnesstms.com/depression-treatment-coral-springs-fl",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/depression-treatment-coral-springs-fl",
        },
      ],
      scripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify(
            buildConditionSchema({
              seoTitle:
                "Ketamine for Depression Treatment Coral Springs, FL | Neuro Wellness",
              seoDescription:
                "Breakthrough IV Ketamine therapy for severe & treatment-resistant depression in Coral Springs, FL. Fast relief within hours at Neuro Wellness TMS Centers.",
              canonical: "/depression-treatment-coral-springs-fl",
              breadcrumbs: [
                { name: "Services", href: "/services-directory" },
                {
                  name: "Conditions Treated",
                  href: "/ketamine-treatment-coral-springs-fl",
                },
                {
                  name: "Depression",
                  href: "/depression-treatment-coral-springs-fl",
                },
              ],
            }),
          ),
        },
      ],
    };
  },
});
function RouteComponent() {
  return <DepressionKetaminePage />;
}
